import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { AlertService } from 'src/app/root/_services/alert.service';
import { ClientLogService } from 'src/app/root/_services/client-log.service';

@Injectable()
export class ErrorsHandler implements ErrorHandler {

	constructor(private injector: Injector) { }

	handleError(error: Error): void {

		const alertService = this.injector.get(AlertService);
		const clientLogService = this.injector.get(ClientLogService);
		console.log("An exception occurred");
		console.error(error);
		if(alertService)
			alertService.error(error.message);
		// clientLogService.error({ "name": error.name, "message": error.message, "stack": error.stack }).subscribe(x => { });
	}
}
